import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM5 16V19H19V16H5ZM5 5V14H19V5H5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "BarBottom"
);
